exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toggle-box{cursor:pointer;vertical-align:middle;height:20px;width:34px;background-color:#bdbdbd;border-radius:10px;position:relative;margin-left:auto}.toggle-box,.toggle-box:after{display:inline-block;transition:all .2s ease}.toggle-box:after{content:\"\";position:absolute;height:16px;width:16px;border-radius:8px;top:2px;background-color:#fff}.toggle-box.off{background-color:#bdbdbd}.toggle-box.off:after{left:2px}.toggle-box.on{background-color:#3cb449}.toggle-box.on:after{left:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader/src!./~/less-loader!./src/components/common/Toggle/index.less
// module id = 2244
// module chunks = 0